import { Auth0ClientOptions } from '@auth0/auth0-spa-js';

/* eslint-disable import/prefer-default-export */
export const UNEXPECTED_LOGIN_ERROR = 'common/unexpectedLoginError';
export const PRODIGAL_LOGO_DARK =
  'https://public.prodigaltech.com/prodigal-logo-dark.svg';
export const PRODIGAL_LOGO_LIGHT =
  'https://public.prodigaltech.com/prodigal-logo-light.svg';

export const ERROR_MESSAGE_PARAM = 'throwError';

export const DEFAULT_AUTH0_CONNECTION = 'VoiceAppLogin';

export const DEFAULT_AUTH0_SCOPE =
  'offline_access read:current_user update:current_user_metadata';

export const AUTH0_CONFIG: Auth0ClientOptions = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN as string,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
  cacheLocation: 'localstorage',
  authorizationParams: {
    audience: process.env.REACT_APP_AUTH0_AUDIENCE as string,
    connection: DEFAULT_AUTH0_CONNECTION,
    scope: DEFAULT_AUTH0_SCOPE,
    redirectUri: `${process.env.REACT_APP_WEBSITE_URL}/callback`,
  },
};
